"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterRootStyle = exports.CloseButton = exports.AlertWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _index = require("../Alert/index.styles");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var ToasterRootStyle = /*#__PURE__*/(0, _styledComponents.createGlobalStyle)(["#toaster-root{position:fixed;bottom:", ";right:", ";z-index:1;overflow:hidden;}"], function (p) {
  return p.theme.tokens.spacing07;
}, function (p) {
  return p.theme.tokens.spacing05;
});
exports.ToasterRootStyle = ToasterRootStyle;

var AlertWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__AlertWrapper",
  componentId: "sc-k45xw3-0"
})(["position:relative;z-index:1;display:flex;width:23rem;margin-right:0.5rem;margin-bottom:", ";transform:translate(100%,0);opacity:1;box-shadow:3px 4px 6px 0 rgba(0,0,0,0.25);&.show-enter-active,&.show-enter-done,&.hide-enter{transition:transform ", "ms ease-out;transform:translate(0,0);}&.hide-enter-active,&.hide-enter-done{transition:transform ", "ms ease-in,opacity ", "ms ease-in;transform:translate(0,100%);opacity:0;z-index:0;}& ", "{flex-grow:1;}& ", ",& ", "{margin-right:", ";}"], function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.transitionInSpeed;
}, function (p) {
  return p.transitionOutSpeed;
}, function (p) {
  return p.transitionOutSpeed;
}, _index.Container, _index.Title, _index.Content, function (p) {
  return p.theme.tokens.spacing06;
});

exports.AlertWrapper = AlertWrapper;

var CloseButton = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  displayName: "indexstyles__CloseButton",
  componentId: "sc-k45xw3-1"
})(["position:absolute;top:", ";right:", ";display:flex;align-items:center;justify-content:center;width:2.5rem;height:2.5rem;padding:", ";border:0 none;background:transparent;cursor:pointer;"], function (p) {
  return p.theme.tokens.spacing03;
}, function (p) {
  return p.theme.tokens.spacing03;
}, function (p) {
  return p.theme.tokens.spacing03;
});

exports.CloseButton = CloseButton;